export const dashboardApiUrls = {
  summary: '/dashboard/total-summery?duration={duration}&isOnboarding={is_onboarding}',
  products: '/dashboard/{type}-products?duration={duration}',
  ratings: '/dashboard/ratings',
  industries: '/dashboard/industries',
  confirmStoreActivity: '/dashboard/store/category',
};
